import {
  Stack,
  Heading,
  Text,
  Grid,
  Card,
  Box,
  Image,
  Flex,
  Link,
} from "@chakra-ui/react";
import ContactForm from "../components/custom/ContactForm";
import FilledButton from "../components/custom/FilledButton";
import { Helmet } from "react-helmet-async";

const ContactScreen = () => {
  const contact = [
    {
      icon: "../assets/call.png",
      title: "Phone",
      desc: "+91 9152832898",
      url: "tel:9152832898",
    },
    {
      icon: "../assets/mail.png",
      title: "Email",
      desc: "contact@gloryservices.work",
      url: "mailto:contact@gloryservices.work",
    },
    {
      icon: "../assets/location.png",
      title: "Location",
      desc: "Mumbai, India",
    },
  ];
  return (
    <>
      {/* Helmet */}
      <Helmet>
        <title>Contact Glory Online Cyber Cafe - Support & Assistance</title>
        <meta
          name="description"
          content="Get in touch with Glory Online Cyber Cafe for quick support. Contact us via phone or email. We're here to help with all your digital service needs."
        />
        <link rel="canonical" href="https://www.gloryservices.work/contact" />
      </Helmet>
      <Box
        bgImage='url("../assets/4.jpg")'
        height={{ base: "350px", md: "450px" }}
        w="full"
        backgroundSize="100% 100%"
        display="flex"
        alignItems="center"
      >
        <Flex
          px={{ base: "5", md: "10", lg: "20" }}
          w="95%"
          justifyContent="space-between"
          gap={20}
        >
          <Stack gap={5} color="white">
            <Heading
              as="h2"
              size={{ base: "2xl", md: "4xl", lg: "5xl" }}
              letterSpacing="4px"
            >
              CONTACT US
            </Heading>
            <Text fontSize={{ base: "sm", md: "md", lg: "lg" }}>
              Need support? Our team is ready to assist you. Fill out the form
              below, and we’ll get back to you as soon as possible.
            </Text>

            <FilledButton
              title="CALL NOW"
              url="tel:9152832898"
              color="#a81414"
              bgColor="#fff"
            />
          </Stack>
          <Image
            display={{ base: "none", md: "block" }}
            src="../assets/contact.svg"
            alt="contact"
            h={{ md: "150px", lg: "200px" }}
          />
        </Flex>
      </Box>

      <Stack py={10} px={{ base: "5", md: "20" }}>
        {/* ContactForm */}
        <ContactForm />

        {/* Grid */}
        <Grid
          templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
          gap={{ base: "5", md: "10", lg: "20" }}
          px={{ base: "5", md: "5", lg: "10" }}
        >
          {contact.map((item, index) => (
            <Card.Root
              key={index}
              boxShadow="rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;"
              color="#a20c0b"
              maxW="xs"
              bgColor="transparent"
              border="0.1px solid #a20c0b"
              borderRadius="2xl"
              _hover={{
                boxShadow:
                  "rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;",
                bgColor: "#a20c0b10",
                transition: "all ease 0.2s",
                backdropFilter: "blur(10px)",
              }}
            >
              <Card.Body gap="4" alignItems={"center"}>
                <Box bg="#f2f2f2" borderRadius="full" w="fit-content">
                  <Image src={item.icon} boxSize="16" />
                </Box>
                <Card.Title fontSize="xl">{item.title}</Card.Title>
                <Link href={item.url} _hover={{ textDecoration: "none" }}>
                  <Card.Description
                    fontSize={{ base: "lg", md: "md", lg: "lg" }}
                  >
                    {item.desc}
                  </Card.Description>
                </Link>
              </Card.Body>
            </Card.Root>
          ))}
        </Grid>
      </Stack>
    </>
  );
};

export default ContactScreen;
